import VueRouter from "vue-router";
import Vue from "vue";
// Ogólne
import LandingViewTemplate from "../view/landing_page/LandingViewTemplate";
import HomeView from "../view/landing_page/HomeView";
import NotFoundView from "../view/NotFoundView";
import ErrorView from "../view/ErrorView";
import SetupPasswordView from "../view/SetupPasswordView";
import SetupPasswordConfirmationView from "../view/SetupPasswordConfirmationView";
import SetupBidderEmailAddressView from "../view/SetupBidderEmailAddressView";
import BiddersView from "../view/public/bidders/BiddersView";
import BidderDetailsView from "../view/public/bidders/BidderDetails";
// Widoki po zalogowaniu
import MainLoggedView from "../view/logged/main/MainLoggedView";
import ProfileViewTemplate from "../view/logged/profile_settings/ProfileViewTemplate";
import LoggedViewTemplate from "../view/logged/LoggedViewTemplate";
import UsersView from "../view/logged/users/UsersView";
import NotificationGroupsView from "../view/logged/notification_groups/NotificationGroupsView";
import AgenciesView from "../view/logged/agencies/AgenciesView";
import AuditLogView from "../view/logged/audit/AuditLogView";
import VolunteersView from "../view/logged/volunteers/VolunteersView";
import DepartmentsView from "../view/logged/departments/DepartmentsView";
import SubBiddersView from "../view/logged/subbidders/SubBiddersView";
import ContestViewTemplate from "../view/logged/contest/ContestViewTemplate";
import ContestListView from "../view/logged/contest/ContestListView";
import ContestPanelView from "../view/logged/contest/ContestPanelView";
import ContestMainDataView from "../view/logged/contest/ContestMainDataView";
import BidderOfferView from "../view/logged/offer/BidderOfferView";
import BidderAllOffersView from "../view/logged/bidder/BidderAllOffersView";
import UnconfirmedUsersView from "../view/logged/unconfirmed_users/UnconfirmedUsersView";
import RealizationYearsView from "../view/logged/realization_years/ContestRealizationYearsView";
import ContestOfferView from "../view/logged/offer/ContestOfferView";
import CommitteesView from "../view/logged/contestCommittees/CommitteesView";
import ContestUserListView from "../view/logged/contest/ContestUserListView";
import ContestActionTemplate from "../view/logged/contest/ContestActionTemplate";
import ContestDocumentsView from "../view/logged/contest/ContestDocumentsView";
import BiddersCollaborationEvaluation from "../view/logged/evaluation/offer/bidders/BiddersCollaborationEvaluation";
import AgencyContestViewTemplate from "../view/logged/agencyContest/AgencyContestViewTemplate";
import AgencyContestListView from "../view/logged/agencyContest/AgencyContestListView";
import AgencyContestActionTemplate from "../view/logged/agencyContest/AgencyContestActionTemplate";
import AgencyContestPanelView from "../view/logged/agencyContest/AgencyContestPanelView";
import AgencyContestMainDataView from "../view/logged/agencyContest/AgencyContestMainDataView";
import AgencyContestRatingSettingsView from "../view/logged/agencyContest/AgencyContestRatingParametersView";
import AllOffersListView from "../view/logged/offer/AllOffersListView";
import TeamsView from "../view/logged/agencyContestTeams/TeamsView";
import ReportView from "../view/logged/report/ReportView";
import ReportFormView from "../view/logged/report/ReportFormView";
// Rejestracja
import RegisterView from "../view/register/RegisterViewTemplate";
import RegisterBidder from "../view/register/register_bidder/RegisterBidderView";
import RegisterVolunteer from "../view/register/register_volunteer/RegisterVolunteerView";
import RegisterCoworker from "../view/register/register_coworker/RegisterCoworkerView";
import RegisterSubsidiary from "../view/register/register_subsidiary/RegisterSubsidiaryView";
import RegistrationCompletedView from "../view/register/RegistrationCompletedView";
// Kontakt
import ContactView from "../view/contact/ContactView";
// Ustawienia
import ParagraphsView from "../view/logged/settings/ParagraphsView";
import LibraryView from "../view/logged/settings/LibraryView";
import LibraryViewReadOnly from "../view/logged/settings/LibraryViewReadOnly";
import LegalFormsView from "../view/logged/settings/LegalFormsView";
import SettingsView from "../view/logged/settings/SettingsView";
import AccreditationCountriesView from "../view/logged/settings/AccreditationCountriesView";
import VolunteerLanguagesView from "../view/logged/settings/VolunteerLanguagesView";
import FormGeneratorView from "../view/logged/form/FormGeneratorView";
import ForbiddenView from "../view/ForbiddenView";
import CurrenciesView from "../view/logged/settings/CurrenciesView";

import {role} from "@/utils/Role";
import ContestFormsView from "../view/logged/contest/ContestFormsView";
import ContestTasksView from "../view/logged/contestTasks/ContestTasksView";
import ContestContantFieldsView from "../view/logged/contestConstantFields/ContestContantFieldsView";
import MyContestOfferListView from "../view/logged/offer/MyContestOfferListView";
import ContestRatingParametersView from "../view/logged/contest/ContestRatingParametersView";
import ContestOfferListView from "../view/logged/offer/ContestOfferListView";
import AgencyContestUserListView from "../view/logged/agencyContest/AgencyContestUserListView";
import ContestManageCommitteesView from "../view/logged/contest/ContestManageCommitteesView";
import DACCodesView from "../view/logged/dac_codes/DACCodesView";
import AgencyTasksView from "../view/logged/agencyContestTasks/AgencyTasksView";
import AgencyProjectListView from "../view/logged/agencyProject/AgencyProjectListView";
import AgencyProjectView from "../view/logged/agencyProject/AgencyProjectView";
import AgencyProjectTypesView from "../view/logged/settings/AgencyProjectTypesView";
import AgencyContestForms from "../view/logged/agencyContest/AgencyContestForms";
import AgencyContestConstantFieldsView from "../view/logged/agencyContest/components/AgencyContestConstantFieldsView";
import NotificationGroupUsersView from "../view/logged/notification_groups/components/NotificationGroupUsersView";
import NotificationGroupListView from "../view/logged/notification_groups/components/NotificationGroupListView";
import EvaluationPanelVue from "../view/logged/evaluation/offer/EvaluationPanelVue";
import SubstantiveEvaluationList from "../view/logged/evaluation/offer/substantive/SubstantiveEvaluationList";
import FormalEvaluationList from "../view/logged/evaluation/offer/formal/FormalEvaluationList";
import SubstantiveEvaluationForm from "../view/logged/evaluation/offer/substantive/SubstantiveEvaluationForm";
import FormalEvaluationForm from "../view/logged/evaluation/offer/formal/FormalEvaluationForm";
import ContestFinancialLimitsView from "../view/logged/contest/ContestFinancialSettingsView";
import ExpertEvaluationList from "../view/logged/evaluation/offer/expert/ExpertEvaluationList";
import ExpertEvaluationForm from "../view/logged/evaluation/offer/expert/ExpertEvaluationForm";
import ContestEvaluationSummaryView from "../view/logged/contest/ContestEvaluationSummaryView";
import ContractTemplatesView from "../view/logged/departments/ContractTemplatesView";
import ProjectViewTemplate from "../view/logged/project/ProjectViewTemplate";
import ProjectView from "../view/logged/project/ProjectView";
import AgencyEvaluationList from "../view/logged/evaluation/offer/agency/AgencyEvaluationList";
import AgencyEvaluationForm from "../view/logged/evaluation/offer/agency/AgencyEvaluationForm";
import FinalEvaluationList from "../view/logged/evaluation/offer/final/FinalEvaluationList";
import FinalEvaluationForm from "../view/logged/evaluation/offer/final/FinalEvaluationForm";
import ChangeUserEmailView from "../view/ChangeUserEmailView";
import SetupUserEmailConfirmationView from "../view/SetupUserEmailConfirmationView";
import ContestCommitteesView from "../view/logged/contest/ContestCommitteesView";
import AllAgencyProjectsListView from "../view/logged/agencyProject/AllAgencyProjectsListView";
import AgencyProjectReadOnlyView from "../view/logged/agencyProject/AgencyProjectReadOnlyView";
import AgencyManageTeamsView from "../view/logged/agencyContest/AgencyContestManageTeamsView";
import ContestProjectListView from "../view/logged/offer/ContestProjectListView";
import ProjectInvoicesView from "../view/logged/project/invoices/ProjectInvoicesView";
import InvoiceEditView from "../view/logged/invoice/InvoiceEditView";
import InvoiceCreateView from "../view/logged/invoice/InvoiceCreateView";
import AgencyProjectEvaluationPanelView
	from "../view/logged/evaluation/agency_project/AgencyProjectEvaluationPanelView";
import AgencyProjectSubstantiveEvaluationList
	from "../view/logged/evaluation/agency_project/substantive/AgencyProjectSubstantiveEvaluationList";
import AgencyProjectFinalEvaluationList
	from "../view/logged/evaluation/agency_project/final/AgencyProjectFinalEvaluationList";
import AgencyProjectExpertEvaluationList
	from "../view/logged/evaluation/agency_project/expert/AgencyProjectExpertEvaluationList";
import AgencyProjectFinalEvaluationForm
	from "../view/logged/evaluation/agency_project/final/AgencyProjectFinalEvaluationForm";
import AgencyProjectExpertEvaluationForm
	from "../view/logged/evaluation/agency_project/expert/AgencyProjectExpertEvaluationForm";
import AgencyProjectSubstantiveEvaluationForm
	from "../view/logged/evaluation/agency_project/substantive/AgencyProjectSubstantiveEvaluationForm";
import ContestReadOnlyOfferView from "../view/logged/offer/ContestReadOnlyOfferView";
import ProjectPanelView from "../view/logged/project/ProjectPanelView";
import ProjectAgreementView from "../view/logged/project/ProjectAgreementView";
import ContestReportTemplatesList from "../view/logged/report_templates/ContestReportTemplatesList";
import DonationContractTemplatesView from "../view/logged/departments/DonationContractTemplatesView";
import AgencyContestReportTemplatesList from "../view/logged/report_templates/AgencyContestReportTemplatesList";
import AllProjectsView from "../view/logged/project_lists/all_projects/AllProjectsView";
import ProjectReadOnlyView from "../view/logged/project/ProjectReadOnlyView";
import ProjectMonitoringReadOnlyView from "../view/logged/project/ProjectMonitoringReadOnlyView";
import FinalReportEditView from "../view/logged/finalReport/FinalReportEditView";
import ProjectEvaluationView from "../view/logged/project/ProjectEvaluationView";
import BidderEvaluationFormView from "../view/logged/project/BidderEvaluationFormView";
import UserProjectsView from "../view/logged/project_lists/user_projects/UserProjectsView";
import AgencyContestEvaluationSummaryView from "../view/logged/agencyContest/AgencyContestEvaluationSummaryView";
import AgencyContestEvaluationTeamsView from "../view/logged/agencyContest/AgencyContestEvaluationTeamsView";
import ProjectDonationContractView from "../view/logged/project/ProjectDonationContractView";
import AgencyAllProjectsListView from "../view/logged/agencyProject/AgencyAllProjectsListView";
import UserSupervisedAgencyProjectsList from "../view/logged/agencyProject/UserSupervisedAgencyProjectsList";
import ApprovedAgencyProjectsView from "../view/logged/agencyProject/ApprovedAgencyProjectsView";
import AllProjectsByAgencyCountryView from "../view/logged/project/AllProjectsByAgencyCountryView";
import ProjectFinalReportView from "../view/logged/project/ProjectFinalReportView";
import ProjectMonitoringList from "../view/logged/project/ProjectMonitoringList";
import ProjectMonitoringFormView from "../view/logged/project/ProjectMonitoringFormView";
import CompareOffersView from "../view/logged/offer/CompareOffersView";
import AgencyDocumentsView from "../view/logged/agencyContest/AgencyDocumentsView";
import ContestReadOnlyDocumentsView from "../view/logged/contest/ContestReadOnlyDocumentsView";
import AgencyDocumentsReadOnlyView from "../view/logged/agencyContest/AgencyDocumentsReadOnlyView";
import BidderProjectsView from "../view/logged/project/BidderProjectsView";
import AllAgencyProjectsView from "../view/logged/agencyContest/AllAgencyProjectsView";
import VolunteerProjectsView from "../view/logged/volunteerProjects/VolunteerProjectsView";
import FinalEvaluationPeekView from "../view/logged/evaluation/offer/final/FinalEvaluationView";
import EmailContentsView from "../view/logged/settings/EmailContentsView";
import AllowancesView from "../view/logged/allowances/AllowancesView";
import ProjectVolunteerReportsView from "../view/logged/project/ProjectVolunteerReportsView";
import ProjectChangesHistory from "../view/logged/project/ProjectChangesHistory";
import AgencyProjectChangesHistory from "../view/logged/agencyProject/AgencyProjectChangesHistory";
import OfferChangesHistory from "../view/logged/offer/OfferChangesHistory";
import ActivityTypeView from "../view/logged/settings/ActivityTypeView";
import AllowedOffersView from "../view/logged/allowances/AllowedOffersView";
import AllowedAgencyProjectsView from "../view/logged/allowances/AllowedAgencyProjectsView";
import AllowedProjectsView from "../view/logged/allowances/AllowedProjectsView";
import EmptyOfferView from "../view/landing_page/components/EmptyOfferView";
import EmptyAgencyApplicationView from "../view/logged/agencyContest/EmptyAgencyApplicationView";
import AgencyProfileViewTemplate from "../view/logged/agencies/AgencyProfileViewTemplate";
import DepartmentProfileViewTemplate from "../view/logged/departments/DepartmentProfileViewTemplate";
import VolunteerProjectsList from "../view/logged/project/VolunteerProjectsList";
import CorrespondenceTemplatesView from "../view/logged/departments/CorrespondenceTemplatesView";
import ProjectCorrespondenceView from "../view/logged/project/ProjectCorrespondenceView";
import BidderPersonalEvaluationsHistoryView
	from "../view/logged/evaluation/offer/bidders/BidderPersonalEvaluationsHistoryView";
import AllBiddersView from "../view/logged/users/AllBiddersView";
import BidderDataViewTemplate from "../view/logged/bidder/BidderDataViewTemplate";
import BidderContestView from "../view/logged/bidder/BidderContestView";
import BidderEvaluationView from "../view/logged/bidder/BidderEvaluationView";
import BidderMonitoringView from "../view/logged/bidder/BidderMonitoringView";
import ContestRankingListView from "../view/logged/contest/ContestRankingListView";
import FinalProtocolView from "../view/logged/contest/components/FinalProtocolView";
import AgencyProjectFinalReportView from "../view/logged/agencyProject/AgencyProjectFinalReportView";
import AgencyProjectMonitoringList from "../view/logged/agencyProject/AgencyProjectMonitoringList";
import AgencyProjectMonitoringFormView from "../view/logged/agencyProject/AgencyProjectMonitoringFormView";
import AgencyProjectMonitoringReportReadOnlyView
	from "../view/logged/agencyProject/components/AgencyProjectMonitoringReportReadOnlyView";
import AgencyProjectFinalReportForm from "../view/logged/agencyProject/AgencyProjectFinalReportForm";
import ContestActionView from "../view/logged/contest/ContestActionView";
import CommitteeCollaborationEvaluation from "../view/logged/evaluation/offer/bidders/CommitteeCollaborationEvaluation";
import ReadOnlyCommitteeCollaborationEvaluation
	from "../view/logged/evaluation/offer/bidders/ReadOnlyCommitteeCollaborationEvaluation";
import AgencyContestActionView from "../view/logged/agencyContest/AgencyContestActionView";
import ProjectAmountView from "../view/logged/project/ProjectAmountView";
import AgencyProjectViewDifferences from "../view/logged/agencyProject/AgencyProjectViewDifferences";
import ProjectLastVersionsDifferencesView from "../view/logged/project/ProjectLastVersionsDifferencesView";
import ProjectSelectedVersionsDifferencesView from "../view/logged/project/ProjectSelectedVersionsDifferencesView";
import ReadOnlyView from "../view/ReadOnlyView";
import FinalReportPrintView from "../view/logged/finalReport/FinalReportPrintView";
import ProjectTermsView from "../view/logged/project/ProjectTermsView";
import ContestSummaryView from "../view/logged/contest/ContestSummaryView";
import AgencyProjectPanelView from "../view/logged/agencyProject/AgencyProjectPanelView";
import AgencyProjectCorrespondenceView from "../view/logged/agencyProject/AgencyProjectCorrespondenceView";
import AgencyProjectAmountsView from "../view/logged/agencyProject/AgencyProjectAmountsView";
import AgencyProjectFinalReportReadOnlyView from "../view/logged/agencyProject/AgencyProjectFinalReportReadOnlyView";
import ProjectSummaryView from "../view/logged/project/ProjectSummaryView";
import FinalReportComparison from "../view/logged/finalReport/FinalReportComparison";
import AgencyContestProjectsListView from "../view/logged/agencyContest/AgencyContestProjectsListView";
import ContestSerialWritingsView from "../view/logged/contest/ContestSerialWritingsView";
import AgencyProjectViewTemplate from "../view/logged/agencyProject/AgencyProjectViewTemplate";
import AgencyProjectSummaryView from "../view/logged/agencyProject/AgencyProjectSummaryView";
import SecretSettings from "@/view/logged/settings/SecretSettings";
import SupervisedProjectsView from "../view/logged/project_lists/supervised_projects/SupervisedProjectsView";
import ContestReadOnlyOfferBudgetView from "../view/logged/offer/ContestReadOnlyOfferBudgetView";
import ContestReadOnlyOfferTimetableView from "../view/logged/offer/ContestReadOnlyOfferTimetableView";
import ContestReadOnlyOfferActivitiesDescriptionView from "../view/logged/offer/ContestReadOnlyOfferActivitiesDescriptionView";
import AllowedReportsView from "../view/logged/allowances/AllowedReportsView";
import AllowedAgencyReportsView from "../view/logged/allowances/AllowedAgencyReportsView";
import ProjectReadOnlyBudgetView from "../view/logged/project/ProjectReadOnlyBudgetView";
import ProjectReadOnlyTimetableView from "../view/logged/project/ProjectReadOnlyTimetableView";
import ProjectReadOnlyActivitiesView from "../view/logged/project/ProjectReadOnlyActivitiesView";
import SystemFixView from "@/view/logged/system/SystemFixView";
import ContestNameView from "@/view/logged/contest/ContestNameView";
import AgencyContestNameView from "@/view/logged/agencyContest/AgencyContestNameView";
import SubBiddersReadOnlyView from "@/view/logged/subbidders/SubBiddersReadOnlyView";
import ResetPasswordView from "@/view/ResetPasswordView";
import FormPreviewView from "../view/logged/form/FormPreviewView";
import AgencyFormPreviewView from "../view/logged/form/AgencyFormPreviewView";


VueRouter.prototype.openInNewTab = function (routeObject) {
	const {href} = this.resolve(routeObject);
	window.open(href, "_blank");
};

Vue.use(VueRouter);


// *** *** WIDOKI *** ***


// Rejestracja

const routes = [

	{path: "*", component: NotFoundView},
	{
		path: "/", component: LandingViewTemplate, children: [
			{
				path: "home", component: HomeView,
				meta: {title: 'Strona główna'}
			},
		],
		redirect: "/home",
	},
	{path: "/empty-offer/:contestId", component: EmptyOfferView},

	{path: "/agency-contest/:contestId/empty-application", component: EmptyAgencyApplicationView, meta: {roles: [role.AGENCY_EMPLOYEE, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR]}},

	{path: "/reset-password", component: ResetPasswordView},

	{path: "/setup-password", component: SetupPasswordView},

	{path: "/setup-password-confirmed", component: SetupPasswordConfirmationView},

	{path: "/setup-email-confirmed", component: SetupUserEmailConfirmationView},

	{path: "/reset-email", component: ChangeUserEmailView},

	{
		path: "/search", component: BiddersView,
		meta: {title: 'Wyszukiwarka'}
	},

	{path: "/bidder-details/:id", component: BidderDetailsView},

	{path: "/setup-bidder-email", component: SetupBidderEmailAddressView},

	{path: "/register-completed", component: RegistrationCompletedView},

	{
		path: "/register", component: RegisterView, children: [
			{
				path: "register_bidder", component: RegisterBidder,
				meta: {title: 'Rejestracja oferenta'}
			},
			{
				path: "register_volunteer", component: RegisterVolunteer,
				meta: {title: 'Rejestracja wolontariusza'}
			},
			{
				path: "register_coworker", component: RegisterCoworker,
				meta: {requiresAuth: true, roles: [role.BIDDER]},
			},
			{
				path: "register_subsidiary", component: RegisterSubsidiary,
				meta: {requiresAuth: true, roles: [role.BIDDER, role.SUB_BIDDER]},
			},
		],
	},
	{
		path: "/contact", 
		component: ContactView,
		name: "contact",
		props: route => ({
			email: route.query.email,
		}),
	},
	{path: "/error", component: ErrorView},
	{path: "/forbidden", component: ForbiddenView},

	{
		path: "/app",
		component: LoggedViewTemplate,
		meta: {requiresAuth: true},
		redirect: "/app/main",
		children: [
			{
				path: "main", component: MainLoggedView,
				meta: {title: 'Strona główna'}
			},
			{
				path: "users",
				component: UsersView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Użytkownicy'
				},
			},
			{
				path: "bidders",
				component: AllBiddersView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Oferenci'
				},
			},
			{
				path: "bidder/:bidderId/sub-bidders",
				component: SubBiddersReadOnlyView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Subkonta'
				},
			},
			{
				path: "bidder-data/:bidderId",
				component: BidderDataViewTemplate,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Aktywność oferenta'
				},
				children: [
					{
						path: "contest-list",
						component: BidderContestView,
						meta: {title: 'Aktywność oferenta'}
					},
					{
						path: "offer-list",
						component: BidderAllOffersView,
						meta: {title: 'Aktywność oferenta'}
					},
					{
						path: "evaluation-list",
						component: BidderEvaluationView,
						meta: {title: 'Aktywność oferenta'}
					},
					{
						path: "monitoring-list",
						component: BidderMonitoringView,
						meta: {title: 'Aktywność oferenta'}
					}
				]
			},
			{
				path: "profile/:userId", component: ProfileViewTemplate,
				meta: {title: 'Profil'}
			},
			{
				path: "agency-profile/:agencyId", component: AgencyProfileViewTemplate,
				meta: {roles: [role.ADMINISTRATOR], title: 'Profil placówki'}
			},
			{
				path: "department-profile/:departmentId", component: DepartmentProfileViewTemplate,
				meta: {roles: [role.ADMINISTRATOR], title: 'Profil departamentu'}
			},
			{
				path: 'allowances/:userId', component: AllowancesView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Udostępnienia'}
			},
			{
				path: 'supervised-projects/:userId', component: SupervisedProjectsView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Projekty opiekuna'
				}
			},
			{
				path: 'offer-allowances', component: AllowedOffersView,
				meta: {title: 'Udostępnienia'}
			},
			{
				path: 'project-allowances', component: AllowedProjectsView,
				meta: {title: 'Udostępnienia'}
			},
			{
				path: 'report-allowances', component: AllowedReportsView,
				meta: {title: 'Udostępnienia'}
			},
			{
				path: 'agency-project-allowances', component: AllowedAgencyProjectsView,
				meta: {title: 'Udostępnienia'}
			},
			{
				path: 'agency-report-allowances', component: AllowedAgencyReportsView,
				meta: {title: 'Udostępnienia'}
			},
			{
				path: "evaluations",
				component: EvaluationPanelVue,
				children: [
					{
						path: "formal",
						component: FormalEvaluationList,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
							title: 'Opinie formalne'
						},
					},
					{
						path: "substantive",
						component: SubstantiveEvaluationList,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
							title: 'Opinie merytoryczne'
						},
					},
					{
						path: "final",
						component: FinalEvaluationList,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
							title: 'Opinie końcowe'
						},
					},
					{
						path: "agency",
						component: AgencyEvaluationList,
						meta: {roles: [role.AGENCY_EMPLOYEE], title: 'Opinie placówki'},
					},
					{
						path: "expert",
						component: ExpertEvaluationList,
						meta: {roles: [role.EXPERT,role.ADMINISTRATOR,role.DEPARTMENT_EMPLOYEE], title: 'Opinie eksperta'},
					},
				],
			},
			{
				path: "agency-evaluations",
				component: AgencyProjectEvaluationPanelView,
				children: [
					{
						path: "substantive",
						component: AgencyProjectSubstantiveEvaluationList,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
							title: 'Opinie merytoryczne'
						},
					},
					{
						path: "final",
						component: AgencyProjectFinalEvaluationList,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
							title: 'Opinie końcowe'
						},
					},
					{
						path: "expert",
						component: AgencyProjectExpertEvaluationList,
						meta: {roles: [role.EXPERT, role.ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE], title: 'Opinie eksperta'},
					},
				],
			},
			{
				path: "all-agency-projects",
				name: "agencyProjects",
				component: AllAgencyProjectsView,
				props: {
					onlyProjects: false
				},
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Wnioski placówek'
				},
			},
			{
				path: "all-submitted-agency-projects",
				name: "agencySubmittedProjects",
				props: {
					onlyProjects: true
				},
				component: AllAgencyProjectsView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Projekty placówek'
				},
			},
			{
				path: "all-offer-list",
				component: AllOffersListView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Oferty'
				},
			},
			{
				path: "offer/:offerId/history",
				component: OfferChangesHistory,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.BIDDER, role.SUB_BIDDER, role.EXPERT],
					title: 'Historia'
				},
			},
			{
				path: "contest",
				component: ContestViewTemplate,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.BIDDER, role.SUB_BIDDER, role.EXPERT, role.VIEWER],
				},
				redirect: "/app/contest/list",
				children: [
					{
						path: "list", component: ContestListView,
						meta: {title: 'Konkursy'}
					},
					{
						path: ":id", component: ContestActionTemplate, children: [
							{
								path: "/",
								component: ContestNameView,
								children: [
									{
										path: "panel",
										component: ContestPanelView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Panel konkursu'
										},
										children: [
											{
												path: "main-data", component: ContestMainDataView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "documents", component: ContestDocumentsView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "users", component: ContestUserListView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "committees", component: CommitteesView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "forms", component: ContestFormsView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "tasks", component: ContestTasksView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "constant-fields", component: ContestContantFieldsView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "rating-parameters", component: ContestRatingParametersView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "financial-limits", component: ContestFinancialLimitsView,
												meta: {title: 'Panel konkursu'}
											},
											{
												path: "action", component: ContestActionView,
												meta: {title: 'Panel konkursu'}
											}
										],
									},
									{
										path: "my-offer-list",
										component: MyContestOfferListView,
										meta: {roles: [role.BIDDER, role.SUB_BIDDER], title: 'Oferty'},
									},
									{
										path: "view-files",
										component: ContestReadOnlyDocumentsView,
										meta: {roles: [role.BIDDER, role.SUB_BIDDER], title: 'Dokumenty konkursowe'},
									},
									{
										path: "offer-list",
										component: ContestOfferListView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Ocena ofert'
										},
									},
									{
										path: "project-list",
										component: ContestProjectListView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Projekty'
										},
									},
									{
										path: "committees",
										component: ContestCommitteesView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Komisje'
										},
									},
									{
										path: "manage-committees",
										component: ContestManageCommitteesView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Komisje'
										},
									},
									{
										path: "evaluation-summary",
										component: ContestEvaluationSummaryView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Ocena zbiorcza'
										},
										children: [
											{
												path: "committees/:committeeId",
												component: ContestEvaluationSummaryView,
												meta: {
													roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
													title: 'Ocena zbiorcza'
												},
											},
										],
									},
									{
										path: "final-ranking",
										component: ContestRankingListView,
										meta: {title: 'Lista rankingowa'}
									},
									{
										path: "final-protocol",
										component: FinalProtocolView,
										meta: {title: 'Protokół końcowy'}
									},
									{
										path: "serial-writings",
										component: ContestSerialWritingsView,
										meta: {title: 'Pisma seryjne'}
									},
									{
										path: "bidders-evaluation",
										component: BiddersCollaborationEvaluation,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Ocena współpracy'
										},
									},
									{
										path: "summary",
										component: ContestSummaryView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Podsumowanie konkursu'
										}
									},
									{
										path: "bidder-personal-evaluations/:bidderId/history",
										component: BidderPersonalEvaluationsHistoryView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Ocena współpracy'
										}
									},
								]
							},
							{
								path: "place-offer/:offerId",
								component: ContestOfferView,
								meta: {
									roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.BIDDER, role.SUB_BIDDER],
									title: 'Oferta'
								},
							},
							{
								path: "formal-evaluation/:evaluationId",
								component: FormalEvaluationForm,
								meta: {title: 'Opinia formalna'}
							},
							{
								path: "substantive-evaluation/:evaluationId",
								component: SubstantiveEvaluationForm,
								meta: {title: 'Opinia merytoryczna'}
							},
							{
								path: "final-evaluation/:evaluationId",
								component: FinalEvaluationForm,
								meta: {title: 'Opinia końcowa'}
							},
							{
								path: "final-evaluation-peek/:evaluationId",
								component: FinalEvaluationPeekView,
								meta: {title: 'Opinia końcowa'}
							},
							{
								path: "agency-evaluation/:evaluationId",
								component: AgencyEvaluationForm,
								meta: {title: 'Opinia placówki'}
							},
							{
								path: "expert-evaluation/:evaluationId",
								component: ExpertEvaluationForm,
								meta: {title: 'Opinia eksperta'}
							},
							{
								path: "collaboration-evaluation/:bidderId",
								component: CommitteeCollaborationEvaluation,
								meta: {title: 'Ocena współpracy'}
							},
						],
					},
				],
			},
			{
				path: "user-projects",
				component: UserProjectsView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Projekty'
				},
			},
			{
				path: "all-projects",
				component: AllProjectsView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Projekty'
				},
			},
			{
				path: "all-agency-offers",
				component: AgencyAllProjectsListView,
				meta: {
					roles: [role.AGENCY_EMPLOYEE],
					title: 'Wnioski placówki'
				},
			},
			{
				path: "approved-agency-projects",
				component: ApprovedAgencyProjectsView,
				meta: {
					roles: [role.AGENCY_EMPLOYEE],
					title: 'Projekty placówki'
				},
			},
			{
				path: "agency-project/:projectId/history",
				component: AgencyProjectChangesHistory,
				meta: {title: 'Historia'}
			},
			{
				path: "all-projects-by-agency-country",
				component: AllProjectsByAgencyCountryView,
				meta: {
					roles: [role.AGENCY_EMPLOYEE],
					title: 'Projekty'
				}
			},
			{
				path: "bidder-offers",
				component: BidderOfferView,
				meta: {
					roles: [role.BIDDER, role.SUB_BIDDER],
					title: 'Oferty'
				},
			},
			{
				path: "project",
				component: ProjectViewTemplate,
				meta: {
					roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER, role.VOLUNTEER, role.AGENCY_EMPLOYEE],
				},
				children: [
					{
						path: "bidder-project-list/:bidderId", component: BidderProjectsView,
						meta: {title: 'Projekty'}
					},
					{
						path: "volunteer-project-list/:volunteerId", component: VolunteerProjectsList,
						meta: {title: 'Projekty'}
					},
					{
						path: ":projectId",
						component: ProjectView,
						meta: {title: 'Projekt'}
					},
					{
						path: ":projectId/invoices",
						component: ProjectInvoicesView,
						meta: {title: 'Dokumenty finansowe'}
					},
					{
						path: ":projectId/invoices/new",
						component: InvoiceCreateView,
						meta: {title: 'Dokumenty'}
					},
					{
						path: ":projectId/final-report",
						component: FinalReportEditView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER], title: 'Sprawozdanie końcowe'},
					},
					{
						path: ":projectId/history",
						component: ProjectChangesHistory,
						meta: {title: 'Historia'}
					},
					{
						path: ":projectId/summary",
						component: ProjectSummaryView,
						meta: {title: 'Podsumowanie projektu'}
					},
					{
						path: ":projectId/volunteer-report/:volunteerReportId", component: ReportFormView, meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VOLUNTEER],
							title: 'Raport'
						},
					},
				],
			},
			{
				path: ":contestId/project-panel/:projectId",
				component: ProjectPanelView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Panel projektu'
				},
				children: [
					{
						path: "agreement", component: ProjectAgreementView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "donation-contract", component: ProjectDonationContractView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "correspondence", component: ProjectCorrespondenceView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "amounts", component: ProjectAmountView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "evaluation", component: ProjectEvaluationView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "volunteer-reports", component: ProjectVolunteerReportsView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "final-report", component: ProjectFinalReportView,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "monitoring", component: ProjectMonitoringList,
						meta: {title: 'Panel projektu'}
					},
					{
						path: "terms", component: ProjectTermsView,
						meta: {title: 'Panel projektu'}
					}
				],
				redirect: ":contestId/project-panel/:projectId/agreement",
			},
			{
				path: ":contestId/:projectId/monitoring-form/:monitoringId", component: ProjectMonitoringFormView,
				meta: {title: 'Monitoring'}
			},
			{
				path: ":contestId/:projectId/evaluation-form/:evaluationId", component: BidderEvaluationFormView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Ocena współpracy'
				}
			},
			{
				path: "invoice/:invoiceId",
				component: InvoiceEditView,
				meta: {
					roles: [role.BIDDER, role.SUB_BIDDER],
					title: 'Dokumenty finansowe'
				},
			},
			{
				path: "agency-contest",
				component: AgencyContestViewTemplate,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.EXPERT, role.VIEWER]},
				redirect: "/app/agency-contest/list",
				children: [
					{
						path: "list", component: AgencyContestListView,
						meta: {title: 'Nabory'}
					},
					{
						path: ":id", component: AgencyContestActionTemplate, children: [
							{
								path: "/",
								component: AgencyContestNameView,
								children: [
									{
										path: "panel",
										component: AgencyContestPanelView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Panel naboru'
										},
										children: [
											{
												path: "main-data", component: AgencyContestMainDataView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "users", component: AgencyContestUserListView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "forms", component: AgencyContestForms,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "teams", component: TeamsView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "rating-settings", component: AgencyContestRatingSettingsView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "documents", component: AgencyDocumentsView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "tasks", component: AgencyTasksView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "constant-fields", component: AgencyContestConstantFieldsView,
												meta: {title: 'Panel naboru'}
											},
											{
												path: "action", component: AgencyContestActionView,
												meta: {title: 'Panel naboru'}
											},
										]
									},
									{
										path: "project-list",
										component: AllAgencyProjectsListView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Opiniowanie wniosków'
										},
									},
									{
										path: "projects",
										component: AgencyContestProjectsListView,
										meta: {title: 'Projekty'}
									},
									{
										path: "evaluation-summary",
										component: AgencyContestEvaluationSummaryView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Ocena zbiorcza'
										},
										children: [
											{
												path: "teams/:teamId",
												component: AgencyContestEvaluationSummaryView,
												meta: {
													roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
													title: 'Ocena zbiorcza'
												},
											},
										],
									},
									{
										path: "evaluation-summary-teams",
										component: AgencyContestEvaluationTeamsView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
											title: 'Zespoły'
										},
									},
									{
										path: "view-files",
										component: AgencyDocumentsReadOnlyView,
										meta: {title: 'Dokumenty naboru'}
									},
									{
										path: "manage-teams",
										component: AgencyManageTeamsView,
										meta: {title: 'Zespoły'}
									},
									// tutaj kolejne
								],
							},
							{
								path: "my-project-list",
								component: AgencyProjectListView,
								meta: {title: 'Wnioski'}
							},
							{
								path: "project/:projectId",
								component: AgencyProjectView,
								meta: {roles: [role.AGENCY_EMPLOYEE], title: 'Projekt'},
							},
							{
								path: "project-panel/:projectId",
								component: AgencyProjectPanelView,
								meta: {title: 'Panel projektu'},
								children: [
									{
										path: "correspondence", component: AgencyProjectCorrespondenceView,
										meta: {title: 'Panel projektu'}
									},
									{
										path: "amounts", component: AgencyProjectAmountsView,
										meta: {title: 'Panel projektu'}
									},
									{
										path: "final-report", component: AgencyProjectFinalReportView,
										meta: {
											roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
											title: 'Panel projektu'
										}
									},
									{
										path: "monitoring", component: AgencyProjectMonitoringList,
										meta: {title: 'Panel projektu'}
									}
								],
								redirect: "project-panel/:projectId/correspondence"
							},
							{
								path: "project-panel/:projectId/final-report/view",
								component: AgencyProjectFinalReportView,
								meta: {title: 'Sprawozdanie końcowe'}
							},
							{
								path: "project-panel/:projectId/final-report/form",
								component: AgencyProjectFinalReportForm,
								meta: {title: 'Sprawozdanie końcowe'}
							},
							{
								path: "final-evaluation/:evaluationId",
								component: AgencyProjectFinalEvaluationForm,
								meta: {title: 'Opinia końcowa'}
							},
							{
								path: "expert-evaluation/:evaluationId",
								component: AgencyProjectExpertEvaluationForm,
								meta: {title: 'Opinia eksperta'}
							},
							{
								path: "substantive-evaluation/:evaluationId",
								component: AgencyProjectSubstantiveEvaluationForm,
								meta: {title: 'Opinia merytoryczna'}
							},
							{
								path: ":projectId/monitoring-form/:monitoringId",
								component: AgencyProjectMonitoringFormView,
								meta: {title: 'Monitoring'}
							},
						],
					},
				],
			},
			{
				path: "agency-project",
				component: AgencyProjectViewTemplate,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE],
				},
				children: [
					{
						path: ":projectId/summary",
						component: AgencyProjectSummaryView,
						meta: {title: 'Podsumowanie projektu'}
					}
				],
			},
			{
				path: "user-supervised-agency-projects",
				component: UserSupervisedAgencyProjectsList,
				meta: {title: 'Projekty'}
			},
			{
				path: "form-generator/:contestType/:contestId/",
				component: FormGeneratorView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT],
					title: 'Formularz'
				},
				children: [
					{
						path: "volunteer-report/:reportId",
						meta: {title: 'Formularz'}
					},
					{
						path: ":formType",
						meta: {title: 'Formularz'}
					},
				],
			},
			{
				path: "sub-bidders",
				component: SubBiddersView,
				meta: {
					roles: [role.BIDDER, role.SUB_BIDDER],
					title: 'Subkonta'
				},
			},
			{
				path: "volunteers",
				component: VolunteersView,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.BIDDER, role.SUB_BIDDER],
					title: 'Wolontariusze'
				},
			},
			{
				path: "agencies", component: AgenciesView, meta: {roles: [role.ADMINISTRATOR], title: 'Placówki'},
			},
			{
				path: "departments",
				component: DepartmentsView,
				meta: {roles: [role.ADMINISTRATOR], title: 'Departamenty'},
			},
			{
				path: "contract-templates/:departmentId",
				component: ContractTemplatesView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Szablony umów'},
			},
			{
				path: "donation-contract-templates/:departmentId",
				component: DonationContractTemplatesView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Szablony kart'},
			},
			{
				path: "correspondence-templates/:departmentId",
				component: CorrespondenceTemplatesView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Szablony pism'},
			},
			{
				path: "contest-report-templates/:departmentId/list",
				component: ContestReportTemplatesList,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Szablony sprawozdań'},
			},
			{
				path: "agency-contest-report-templates/:departmentId/list",
				component: AgencyContestReportTemplatesList,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Szablony sprawozdań'},
			},
			{
				path: ":reportTemplatesType/:departmentId/form/:templateId",
				component: FormGeneratorView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Formularz'},
			},
			{
				path: "notification-groups",
				component: NotificationGroupsView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE]},
				children: [
					{
						path: ":departmentId/list",
						component: NotificationGroupListView,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
							title: 'Komunikaty grupowe'
						},
					},
					{
						path: ":departmentId/users/:groupId",
						component: NotificationGroupUsersView,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
							title: 'Komunikaty grupowe'
						},
					},
				],
			},
			{
				path: "unconfirmed-users",
				component: UnconfirmedUsersView,
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR], title: 'Niepotwierdzeni użytkownicy'},
			},
			{
				path: "system-fix",
				component: SystemFixView,
				meta: {roles: [role.ADMINISTRATOR], title: 'Naprawienie błędów systemu'},
			},
			{
				path: "audit-log",
				component: AuditLogView,
				meta: {roles: [role.ADMINISTRATOR], title: 'Logi systemowe'},
			},
			{
				path: "realization-years",
				component: RealizationYearsView,
				meta: {roles: [role.ADMINISTRATOR], title: 'Lata realizacji'},
			},
			{
				path: "report", component: ReportView, meta: {roles: [role.VOLUNTEER], title: 'Raporty'},
			},
			{
				path: "volunteer-projects", component: VolunteerProjectsView, meta: {title: 'Projekty'}
			},
			{
				path: "settings",
				component: SettingsView,
				meta: {roles: [role.ADMINISTRATOR]},
				children: [
					{
						path: "library", component: LibraryView,
						meta: {title: 'Biblioteka'}
					},
					{
						path: "paragraphs", component: ParagraphsView,
						meta: {title: 'Paragrafy'}
					},
					{
						path: "legal-forms", component: LegalFormsView,
						meta: {title: 'Formy prawne'}
					},
					{
						path: "currencies", component: CurrenciesView,
						meta: {title: 'Waluty'}
					},
					{
						path: "activity-types", component: ActivityTypeView,
						meta: {title: 'Rodzaje działalności'}
					},
					{
						path: "accreditation-countries", component: AccreditationCountriesView,
						meta: {title: 'Kraje'}
					},
					{
						path: "volunteer-languages", component: VolunteerLanguagesView,
						meta: {title: 'Języki wolontariuszy'}
					},
					{
						path: "dac-codes", component: DACCodesView,
						meta: {title: 'Kody DAC'}
					},
					{
						path: "agency-project-types", component: AgencyProjectTypesView,
						meta: {title: 'Typy projektów'}
					},
					{
						path: "email-contents", component: EmailContentsView,
						meta: {title: 'Powiadomienia systemowe'}
					},
					{
						path: "secret-settings", component: SecretSettings,
						meta: {
							roles: [role.ADMINISTRATOR],
							title: 'Panel administratora'
						},
					}
				],
			},
			{
						path: "library", component: LibraryViewReadOnly,
						meta: {roles: [role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.EXPERT, role.BIDDER, role.SUB_BIDDER, role.VOLUNTEER, role.VIEWER], title: 'Biblioteka'},
			},
		],
	},
	{
		path: "/print/LrZ63OJBjtb4Iii5sBuRDC2X8JlygwCcIiehxloouW4RqqTtS0djoXr75zGeEUXh",
		component: ReadOnlyView,
		children: [
			{
				path: "contest/:id",
				component: ContestActionTemplate,
				children: [
					{
						path: "offer/:offerId",
						component: ContestReadOnlyOfferView
					},
					{
						path: "offer/:offerId/module/:module",
						component: ContestReadOnlyOfferView
					},
					{
						path: "offer/:offerId/module/:module/:version",
						component: ContestReadOnlyOfferView
					},
					{
						path: "offer/:offerId/:version",
						component: ContestReadOnlyOfferView,
					},
					{
						path: "offer-budget/:offerId/:version?",
						component: ContestReadOnlyOfferBudgetView,
					},
					{
						path: "offer-budget/:offerId/module/:module/:version?",
						component: ContestReadOnlyOfferBudgetView,
					},
					{
						path: "offer-timetable/:offerId/:version?",
						component: ContestReadOnlyOfferTimetableView,
					},
					{
						path: "offer-timetable/:offerId/module/:module/:version?",
						component: ContestReadOnlyOfferTimetableView,
					},
					{
						path: "offer-activities/:offerId/:version?",
						component: ContestReadOnlyOfferActivitiesDescriptionView,
					},
					{
						path: "offer-activities/:offerId/module/:module/:version?",
						component: ContestReadOnlyOfferActivitiesDescriptionView,
					},
					{
						path: "final-protocol",
						component: FinalProtocolView,
					},
					{
						path: "formal-evaluation/:evaluationId",
						component: FormalEvaluationForm,
					},
					{
						path: "final-evaluation/:evaluationId",
						component: FinalEvaluationForm,
					},
					{
						path: "substantive-evaluation/:evaluationId",
						component: SubstantiveEvaluationForm,
					},
					{
						path: "agency-evaluation/:evaluationId",
						component: AgencyEvaluationForm,
					},
					{
						path: "expert-evaluation/:evaluationId",
						component: ExpertEvaluationForm,
					},
					{
						path: "collaboration-evaluation/:bidderId",
						component: ReadOnlyCommitteeCollaborationEvaluation,
					}
				]
			},
			{
				path: "project/:projectId",
				component: ProjectViewTemplate,
				children: [
					{
						path: "", component: ProjectReadOnlyView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER, role.AGENCY_EMPLOYEE]},
					},
					{
						path: "final-report", component: FinalReportPrintView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER]}
					},
					{
						path: "budget/:version?",
						component: ProjectReadOnlyBudgetView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER, role.AGENCY_EMPLOYEE]},
					},
					{
						path: "timetable/:version?",
						component: ProjectReadOnlyTimetableView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER, role.AGENCY_EMPLOYEE]},
					},
					{
						path: "activities/:version?",
						component: ProjectReadOnlyActivitiesView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER, role.AGENCY_EMPLOYEE]},
					},
					{
						path: ":version", component: ProjectReadOnlyView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VIEWER]}
					},
					{
						path: "volunteer-report/:volunteerReportId", component: ReportFormView, meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.VOLUNTEER]
						},
					},
					{
						path: "monitoring-form/:monitoringId", component: ProjectMonitoringReadOnlyView,
						meta: {roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER]}
					},
				]
			},
			{
				path: "agency-contest/:id",
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.EXPERT, role.VIEWER]},
				component: AgencyContestActionTemplate,
				children: [
					{
						path: "final-report/:projectId",
						component: AgencyProjectFinalReportReadOnlyView
					},
					{
						path: "project/:agencyId/:projectId/:version",
						component: AgencyProjectReadOnlyView,
					},
					{
						path: "project/:agencyId/:projectId",
						component: AgencyProjectReadOnlyView,
					},
					{
						path: "final-evaluation/:evaluationId",
						component: AgencyProjectFinalEvaluationForm,
					},
					{
						path: "expert-evaluation/:evaluationId",
						component: AgencyProjectExpertEvaluationForm,
					},
					{
						path: "substantive-evaluation/:evaluationId",
						component: AgencyProjectSubstantiveEvaluationForm,
					},
				]
			},
			{
				path: "agency-project/:projectId",
				component: AgencyContestActionTemplate,
				children: [
					{
						path: "monitoring-form/:monitoringId",
						component: AgencyProjectMonitoringReportReadOnlyView,
						meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.AGENCY_EMPLOYEE]}
					}
				]
			},
			{
				path: ":contestId/:projectId/evaluation-form/:evaluationId", component: BidderEvaluationFormView,
			},
			{
				path: "form-preview/:contestId/:formType/:reportId?",
				component: FormPreviewView,
			},
			{
				path: "agency-form-preview/:contestId/:formType/:reportId?",
				component: AgencyFormPreviewView,
			}
		]
	},
	{
		path: "/view",
		component: ReadOnlyView,
		meta: {
			requiresAuth: true,
		},
		children: [
			{
				path: "profile/:userId", component: ProfileViewTemplate,
				name: "profileView", meta: {title: 'Profil'},
				props: {editable: false},
			},
			{
				path: "contest/:id",
				component: ContestActionTemplate,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.BIDDER, role.SUB_BIDDER, role.EXPERT, role.VIEWER],
				},
				children: [
					{
						path: "offer/:offerId",
						component: ContestReadOnlyOfferView,
						meta: {title: 'Oferta'}
					},
					{
						path: "offer/:offerId/:version",
						component: ContestReadOnlyOfferView,
						meta: {title: 'Oferta'}
					},
					{
						path: "compare-offers/:offerId/:firstVersion/:secondVersion",
						component: CompareOffersView,
						meta: {title: 'Porównanie'}
					},
					{
						path: "collaboration-evaluation/:bidderId",
						component: ReadOnlyCommitteeCollaborationEvaluation,
						meta: {title: 'Ocena współpracy'}
					},
				],
			},
			{
				path: "agency-contest/:id",
				meta: {roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.AGENCY_EMPLOYEE, role.EXPERT, role.VIEWER]},
				component: AgencyContestActionTemplate,
				children: [
					{
						path: "final-report/:projectId",
						component: AgencyProjectFinalReportReadOnlyView,
						meta: {title: 'Sprawozdanie końcowe'}
					},
					{
						path: "compare-projects/:projectId/:firstVersion/:secondVersion",
						component: AgencyProjectViewDifferences,
						meta: {title: 'Porównanie'}
					},
					{
						path: "project/:agencyId/:projectId/:version",
						component: AgencyProjectReadOnlyView,
						meta: {title: 'Projekt'}
					},
					{
						path: "project/:agencyId/:projectId",
						component: AgencyProjectReadOnlyView,
						meta: {title: 'Projekt'}
					},
				],
			},
			{
				path: "final-report/:projectId/comparison/:firstVersion/:secondVersion",
				component: FinalReportComparison,
				meta: {
					roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
					title: 'Porównanie sprawozdań'
				}
			},
			{
				path: "project/:projectId",
				component: ProjectViewTemplate,
				children: [
					{
						path: "", component: ProjectReadOnlyView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER, role.AGENCY_EMPLOYEE],
							title: 'Projekt'
						},
					},
					{
						path: "final-report", component: FinalReportPrintView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER, role.AGENCY_EMPLOYEE],
							title: 'Sprawozdanie końcowe'
						}
					},
					{
						path: "compare", component: ProjectLastVersionsDifferencesView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER],
							title: 'Porównanie'
						}
					},
					{
						path: "compare/:firstVersion/:secondVersion", component: ProjectSelectedVersionsDifferencesView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER],
							title: 'Porównanie'
						}
					},
					{
						path: ":version", component: ProjectReadOnlyView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER],
							title: 'Projekt'
						}
					},
					{
						path: "monitoring-form/:monitoringId", component: ProjectMonitoringReadOnlyView,
						meta: {
							roles: [role.BIDDER, role.SUB_BIDDER, role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE, role.EXPERT, role.VIEWER],
							title: 'Monitoring'
						}
					}
				],
			},
			{
				path: "agency-project/:projectId",
				component: AgencyContestActionTemplate,
				children: [
					{
						path: "monitoring-form/:monitoringId",
						component: AgencyProjectMonitoringReportReadOnlyView,
						meta: {
							roles: [role.ADMINISTRATOR, role.LOCAL_ADMINISTRATOR, role.DEPARTMENT_EMPLOYEE],
							title: 'Monitoring'
						}
					}
				]
			}
		],
	},
];

export default new VueRouter({
	mode: "history",
	routes,
});
